import { FirestoreService } from '../../../sdk/firestoreService';

// Action Creators
export const updateDashboardStart = () => ({
    type: 'UPDATE_DASHBOARD_START'
});

export const updateDashboardSuccess = (dashboard) => ({
    type: 'UPDATE_DASHBOARD_SUCCESS',
    payload: dashboard
});

export const updateDashboardFailure = (error) => ({
    type: 'UPDATE_DASHBOARD_FAILURE',
    payload: error
});

/**
 * saveWidgets - שמירת שינויים בדשבורד ועדכון savedWidgets
 * @param {string} dashboardId - מזהה הדשבורד
 * @param {Array} widgets - מערך הווידג'טים
 * @param {Object} settings - הגדרות הדשבורד
 * @param {string} organizationId - מזהה הארגון
 * @param {Array} savedWidgets - רכיבים שמורים ברמת ארגון (מ-Redux)
 */
export const saveWidgets = (dashboardId, widgets, settings, organizationId, savedWidgets = []) => async (dispatch) => {
    try {
        dispatch(updateDashboardStart());

        console.log('💾 Saving dashboard to Firestore:', {
            dashboardId,
            widgetsCount: widgets.length,
            widgets: widgets.map(w => ({ widgetId: w.widgetId, componentKey: w.componentKey })),
            organizationId,
            savedWidgetsCount: savedWidgets.length
        });

        // שמור את הדשבורד
        await FirestoreService.updateDashboard(dashboardId, widgets, settings);
        console.log('✅ Dashboard saved successfully');

        // עדכן את savedWidgets ב-Firestore (אם יש organizationId)
        if (organizationId && savedWidgets) {
            console.log('💾 Updating savedWidgets in Firestore:', {
                organizationId,
                savedWidgetsCount: savedWidgets.length
            });

            await FirestoreService.updateOrganization(organizationId, {
                savedWidgets: savedWidgets
            });

            console.log('✅ SavedWidgets updated successfully');
        }

        // טען את הדשבורד המעודכן
        const updatedDashboard = await FirestoreService.getDashboard(dashboardId);

        console.log('📦 Loaded updated dashboard:', {
            dashboardId: updatedDashboard?.dashboardId,
            hasWidgets: !!updatedDashboard?.current?.widgets,
            widgetsCount: updatedDashboard?.current?.widgets?.length || 0,
            widgets: updatedDashboard?.current?.widgets?.map(w => ({ widgetId: w.widgetId, componentKey: w.componentKey })),
            fullDashboard: updatedDashboard
        });

        console.log('📤 Dispatching UPDATE_DASHBOARD_SUCCESS with dashboard:', {
            dashboardId: updatedDashboard?.dashboardId,
            hasPayload: !!updatedDashboard,
            structure: JSON.stringify(updatedDashboard, null, 2).substring(0, 500)
        });

        dispatch(updateDashboardSuccess(updatedDashboard));
        return { success: true };
    } catch (error) {
        console.error('❌ Error saving dashboard:', error);
        dispatch(updateDashboardFailure(error.message));
        throw error;
    }
};
